import { render, staticRenderFns } from "./PosterBatchCreation.vue?vue&type=template&id=0fcc9a04"
import script from "./PosterBatchCreation.vue?vue&type=script&lang=js"
export * from "./PosterBatchCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports